import { useCurrentTenant } from 'core/features/auth/tenant.store';
import { useQuery } from "react-query";
import axios from "infra/http";

function useAreaComumValorData(id?: string, date?: string, unidadeId?: string) {
  const {tenant} = useCurrentTenant();

  return useQuery(
    `v1/area-comum/${id}/valor/${date}}/${unidadeId}`,
    async () => {
      const { data } = await axios.get<{valor: number | null}>(
        `v1/tenants/${tenant.id}/area-comum/${id}/valor/${date}`, {
          params: {
            unidadeId
          }
        }
      );

      return data.valor;
    },
    {
      enabled: !!id && !!date,
    }
  );
}

export default useAreaComumValorData;
